module.exports = __webpack_public_path__ + "img/avatar2.27e34d79.png";